import React from 'react'
import PropTypes from 'prop-types'
import {defineMessages, useIntl} from 'react-intl'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'

const LocaleText = ({shortCode}) => {
    const intl = useIntl()
    const message = LOCALE_MESSAGES[shortCode]

    if (!message) {
        logger.error(
            `No locale message found for "${shortCode}". Please update the list accordingly.`,
            {
                namespace: 'LocaleText',
                additionalProperties: {shortCode}
            }
        )
        return <>Unknown {shortCode}</>
    }

    return <>{intl.formatMessage(message)}</>
}

LocaleText.displayName = 'LocaleText'

LocaleText.propTypes = {
    /**
     * The locale shortcode that you would like the localized text for.
     */
    shortCode: PropTypes.string.isRequired
}

export default LocaleText

const LOCALE_MESSAGES = defineMessages({
    // de
    'de-AT': {id: 'locale_text.message.de-AT', defaultMessage: 'German (Austria)'},
    'de-CH': {id: 'locale_text.message.de-CH', defaultMessage: 'German (Switzerland)'},
    'de-DE': {id: 'locale_text.message.de-DE', defaultMessage: 'German (Germany)'},
    //nl
    'nl-BE': {id: 'locale_text.message.nl-BE', defaultMessage: 'Dutch (Belgium)'},
    'nl-NL': {id: 'locale_text.message.nl-NL', defaultMessage: 'Dutch (The Netherlands)'},
    // en
    'en-GB': {id: 'locale_text.message.en-GB', defaultMessage: 'English (United Kingdom)'},
    'en-DE': {id: 'locale_text.message.en-DE', defaultMessage: 'English (Germany)'},
    'en-CH': {id: 'locale_text.message.en-CH', defaultMessage: 'English (Switzerland)'},
    //
    'fr-BE': {id: 'locale_text.message.fr-BE', defaultMessage: 'French (Belgium)'},
    'fr-CH': {id: 'locale_text.message.fr-CH', defaultMessage: 'French (Switzerland)'},
    'fr-FR': {id: 'locale_text.message.fr-FR', defaultMessage: 'French (France)'},
    // it
    'it-CH': {id: 'locale_text.message.it-CH', defaultMessage: 'Italian (Switzerland)'},
    'it-IT': {id: 'locale_text.message.it-IT', defaultMessage: 'Italian (Italy)'}
})
